import React from 'react'
import PropTypes from 'prop-types'

// Const
import { PATH_PAYMENT_CONTRACT } from 'routes/paths'

// Model
import ContractModel from 'models/Contract'

// Components
import Text from 'ui/Text'
import Link from 'ui/Link'
import Datalist from 'ui/DataList'

export const ContractInfo = ({ contract, lessorId, vendorId, companyId }) => {
  const data = [
    {
      id: 'companyCode',
      label: 'Company code:',
      value: contract.companyCode,
    },
    {
      id: 'vendorCode',
      label: 'Vendor code:',
      value: contract.vendorCode,
    },
    {
      id: 'contractNo',
      label: 'Contract no.:',
      value: contract.contractNumber,
    },
    {
      id: 'status',
      label: 'Status:',
      value: (
        <Text id="status" color={contract.statusColor}>
          ● {contract.status}
        </Text>
      ),
    },
  ]
  return (
    <>
      <Text size={13} paddingTop={25} color="#000000">
        Showing:
      </Text>
      <Text size={18} bold color="#000000">
        {contract.lessorName}
      </Text>
      <Link
        path={PATH_PAYMENT_CONTRACT}
        params={{
          contractNumber: contract.contractNumber,
          vendorCode: contract.vendorCode,
          companyCode: contract.companyCode,
        }}
        query={{ lessorId, vendorId, companyId }}
        underline
      >
        View full contract details
      </Link>
      <Datalist data={data} narrow={true} color="secondary" />
    </>
  )
}

ContractInfo.propTypes = {
  lessorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  vendorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  contract: PropTypes.instanceOf(ContractModel),
}

ContractInfo.defaultProps = {
  lessorId: '',
  vendorId: '',
  companyId: '',
  contract: new ContractModel(),
}

export default ContractInfo
